export default {
  hero: {
    eyebrow: "O centro de recursos Basetao Spreadsheet",
    h1: "Basetao Spreadsheet: encontre produtos, compare vendedores e compre melhor",
    desc: "Explore recursos organizados da Basetao Spreadsheet, achados de produtos, guias de vendedores, informações de QC, guias de envio, avaliações e conselhos práticos de compra — tudo em um hub rápido e pesquisável.",
    secondary: "Procurando produtos, verificando um vendedor, comparando opções de envio ou pesquisando se a Basetao é legítima? Comece aqui.",
    trust: "Recurso independente · Atualizado com frequência · Focado em segurança · Multilíngue",
  },
  popular: {
    title: "Tópicos populares",
  },
  value: {
    h2: "Tudo o que você precisa para entender a Basetao",
    sub: "Um ponto de partida claro e honesto para pesquisa de produtos, verificação de vendedores e compras mais seguras.",
    card1: {
      title: "Recursos Spreadsheet",
      desc: "Recursos de produtos e categorias organizados para explorar achados mais rápido.",
    },
    card2: {
      title: "Pesquisa de vendedores",
      desc: "Aprenda a comparar vendedores e avaliar as informações do produto antes de pedir.",
    },
    card3: {
      title: "Guias de QC",
      desc: "Entenda as fotos QC e o que verificar antes do envio dos seus itens.",
    },
    card4: {
      title: "Guias de envio",
      desc: "Domine peso, peso volumétrico, linhas de envio e seguro.",
    },
    card5: {
      title: "Avaliações independentes",
      desc: "Artigos equilibrados sobre experiência, taxas, armazém e riscos.",
    },
    card6: {
      title: "Segurança em primeiro lugar",
      desc: "Detecte links falsos, descontos enganosos e pedidos de pagamento arriscados.",
    },
  },
  about: {
    h2: "O que é Basetao Spreadsheet?",
    p1: "Basetao Spreadsheet se refere aos recursos compartilhados e organizados que as pessoas usam para descobrir produtos, comparar vendedores e acompanhar os itens antes de fazer um pedido. Transforma links de produtos dispersos em um plano de compra mais claro.",
    p2: "Como os dados de produtos e vendedores mudam rápido, focamos em explicar como esses recursos funcionam e o que verificar — em vez de apresentar preços fixos ou garantias.",
  },
  review: {
    h2: "A Basetao é legítima? Leia as evidências antes de comprar",
    copy: "Nosso conteúdo separa fatos, feedback de usuários e análise editorial para que você possa decidir por conta própria.",
    cta: "Ler o guia de legitimidade da Basetao",
  },
  shipping: {
    h2: "Custo de envio da Basetao: o que realmente afeta o preço?",
    copy: "Os custos de envio podem depender do destino, peso, peso volumétrico, linha de envio, dimensões, seguro e outros fatores.",
    cta: "Saiba mais sobre custos de envio",
  },
  safety: {
    h2: "Compre melhor. Verifique antes de pagar.",
    item1: "Verifique as URLs antes de clicar",
    item2: "Nunca compartilhe suas senhas",
    item3: "Verifique os vendedores com cuidado",
    item4: "Verifique as evidências do produto",
    item5: "Verifique os cupons",
    item6: "Entenda os termos de envio",
    cta: "Abrir a lista de segurança",
  },
  articleSection: {
    h2: "Comece com nosso guia aprofundado",
    copy: "Curioso se a Basetao é legítima e como se manter seguro? Leia nosso artigo completo, escrito de forma independente.",
    cta: "Ler o artigo completo",
  },
  guides: {
    h2: "Guias aprofundados sobre a Basetao",
    sub: "Dez guias originais e independentes sobre produtos, vendedores, QC, envio, armazém, cupons, segurança e comparações.",
  },
  cta: {
    h2: "Pronto para explorar os recursos da Basetao Spreadsheet?",
    copy: "Comece com o guia principal e explore produtos, vendedores, QC, envio, avaliações e segurança.",
    primary: "Basetao Spreadsheet",
    secondary: "Comprar agora",
  },
};